import * as React from 'react';
import { Radio } from '@common/components/radio';
import cx from 'classnames';
import { getTestAttributes } from '@common/utils/tests';
import { MODULE_NAME } from '@modules/fhq-design-tool/constants/shared';
import { Field } from '../field';
import { IInputComponent } from '@modules/fhq-design-tool/types/input-component';

import './radio-group.styles.scss';

export type RadioGroupValue = string | number;

export type RadioGroupProps = IInputComponent<RadioGroupValue | undefined, RadioGroupValue> & {
  labelWidth?: number;
  label?: string;
  options: Array<{ id: RadioGroupValue; name: string; }>
};

export const RadioGroup: React.FC<RadioGroupProps> = (props) => {
  const { className, disabled, label, labelWidth, onChange, value, metadata, description, required, margin, options } = props;

  const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  }, [onChange]);

  return (
    <Field 
      labelWidth={labelWidth} 
      label={label} 
      disabled={disabled}
      className={cx('FhqDesignToolRadioGroup', className)}
      description={description}
      required={required}
      margin={margin}
      classes={{
        input: 'FhqDesignToolRadioGroup__input-wrapper'
      }}
    >
      {options.map((x) => (
        <Radio 
          key={x.id}
          className="FhqDesignToolRadioGroup__input"
          {...getTestAttributes(MODULE_NAME, metadata.description, 'radio', x.id)}
          value={x.id}
          checked={value?.toString() === x.id.toString()} 
          onChange={handleChange} 
        >
          {x.name}
        </Radio>
      ))}
    </Field>
  );
};